import * as React from 'react';
import { RemoteData } from '@assetmark/ui-kit/dist/utils/remote-data.utils';
import styles from './analysis.module.css';

import Button from '../../components/common/button/button';
import { AnalysisSideBarComponent } from './sidebar/sidebar.component';
import { TooltipComponent } from './tooltip/tooltip.component';

import { useLead } from '../../contexts/lead/lead.context';
import { useApp } from '../../contexts/app/app.context';

import { TAnalysisStaticImage } from '../../models/analysis-static-image.model';
import { TAnalysisAccountDetailResponse } from '../../models/analysis-account-details.model';
import { TLeadRiskResponse } from '../../models/lead-risk-response';
import { TAdvisorContractResponse } from '../../models/advisor-contract.model';
import { getCoverPagePdfData, getFirstPagePdfData, getSecondPagePdfData, 
	getThirdPagePdfData, getFourthPagePdfData, getFifthPagePdfData, getSixthPagePdfData, b64toBlob, getByteArrayStringFromBlob } from '../../helpers/print.helper';
import { getAdvisorDetails, getLogoPath } from '../../helpers/analysis.helper';
import { useEffect, useState } from 'react';

import { PDFModal } from '../../components/common/pdf-modal/pdf-modal.component';
import { AnalysisApi } from '../../apis/analysis.api';
import { getAzureResource, getBase64ImageFromUrl } from '../../helpers/resource.helper';
import FullPageLoader from '../../components/common/full-page-loader/fullPageLoader';
import { LeadApi } from '../../apis/lead.api';
import { apiClientsErrors$ } from '../../apis/api.client';

type TStateProps = {
	leadRisk: TLeadRiskResponse;
	riskToleranceImages: RemoteData<TAnalysisStaticImage[]>;
	staticImagesUrls: RemoteData<TAnalysisStaticImage[]>;
	goalAccountDetails: TAnalysisAccountDetailResponse;
	advisorDetails: TAdvisorContractResponse;
	savedPdfUrl: string;
	getGoalDetailsOnLoad: (leadStgId: string, agentId: string) => void;
	getAdvisorContractDetailsOnLoad: (agentId: string) => void;
	saveLoadPdf: (leadId: string, agentId: string, pages: string[]) => void;
};

export const YourAnalysisComponent: React.FC<TStateProps> = ({
	riskToleranceImages,
	staticImagesUrls,
	getGoalDetailsOnLoad,
	goalAccountDetails,
	leadRisk,
	getAdvisorContractDetailsOnLoad,
	advisorDetails,
	saveLoadPdf,
	savedPdfUrl
}) => {
	const { agentId, leadProfileId, leadStrategyId, leadProfile } = useLead();
	const { applicationState } = useApp();
	const [showTooltip, setShowTooltip] = useState(false);
	const [base64StringArray, setBase64StringArray] = useState<string[]>([]);
	const [selectedRiskProfilImgUrl, SetselectedRiskProfilImgUrl] = useState<string>("");
	const [staticFinancialImg1, SetstaticFinancialImg1] = useState<string>("");
	const [staticFinancialImg2, SetstaticFinancialImg2] = useState<string>("");
	const [staticFinancialImg3, SetstaticFinancialImg3] = useState<string>("");
	const [staticFinancialImg4, SetstaticFinancialImg4] = useState<string>("");
	const [advisorPhotoBase64Img, SetAdvisorPhotoBase64Img] = useState<any>(null);
	const [advisorLogoBase64Img, SetAdvisorLogoBase64Img] = useState<any>(null);
	const [pdfUrl, SetPdfUrl] = useState<string>("");
	const [advisorDetail,setAdvisorDetail] = useState<TAdvisorContractResponse>({});
	
	useEffect(()=>{
		if(applicationState && advisorDetails) {
		    setAdvisorDetail({
				...advisorDetails,
				company: applicationState.wordMark.getOrElse('')
			});
		}
	},[applicationState, advisorDetails]);

	useEffect(() => {
		if (leadStrategyId && agentId) {
			getGoalDetailsOnLoad(leadStrategyId, agentId);
		}
	}, [agentId, leadStrategyId]);

	useEffect(() => {
		if (agentId) {
			getAdvisorContractDetailsOnLoad(agentId);
		}
	}, [agentId]);

	useEffect(() => {
		if(base64StringArray.length === 7) {
			base64StringArray.every(b => (b && b.length > 0)) && saveLoadPdf(leadProfileId, agentId, base64StringArray);
			// show modal window 
		}
	}, [base64StringArray]);

	useEffect(() => {
		if(riskToleranceImages.isSuccess() && goalAccountDetails.riskProfile) {
			const url =  riskToleranceImages.value
			.find(img => img.index.getOrElse(0) === Number(goalAccountDetails.riskProfile || 0))
			?.imageUri.getOrElse('');
			url && getAzureResource(url).then(d => SetselectedRiskProfilImgUrl(d)); 
		}
	}, [riskToleranceImages, goalAccountDetails]);

	useEffect(()=> {
		if(staticImagesUrls.isSuccess()) {
			const imgUrlsStatic = staticImagesUrls.value;
			const urlImg1 = imgUrlsStatic.find(img => img.index.getOrElse(0) === 1)?.imageUri.getOrElse('');
			const urlImg2 = imgUrlsStatic.find(img => img.index.getOrElse(0) === 2)?.imageUri.getOrElse('');
			const urlImg3 = imgUrlsStatic.find(img => img.index.getOrElse(0) === 3)?.imageUri.getOrElse('');
			const urlImg4 = imgUrlsStatic.find(img => img.index.getOrElse(0) === 4)?.imageUri.getOrElse('');

			urlImg1 && getAzureResource(urlImg1).then(d => SetstaticFinancialImg1(d)); 
			urlImg2 && getAzureResource(urlImg2).then(d => SetstaticFinancialImg2(d)); 
			urlImg3 && getAzureResource(urlImg3).then(d => SetstaticFinancialImg3(d)); 
			urlImg4 && getAzureResource(urlImg4).then(d => SetstaticFinancialImg4(d)); 
		}
	}, [staticImagesUrls]);

	useEffect(() => {
		if (savedPdfUrl) {
			getAzureResource(savedPdfUrl).then(d => {
				LeadApi.showSpinner$.next(false);
				if ((navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/Mobile/i) || navigator.userAgent.match(/iPod/i) || (navigator.userAgent.match(/Macintosh/i) && navigator.maxTouchPoints > 1))) {
					const anchor = document.createElement('a');
					anchor.href = d;
					// anchor.target = '_blank';
					anchor.download = d.substr(d.lastIndexOf('/') + 1);
					document.body.appendChild(anchor);
					anchor.click();
					document.body.removeChild(anchor);
					// window.open(savedPdfUrl);
				} else {
					SetPdfUrl(d);
				}
			});
		}
	}, [savedPdfUrl]);

	useEffect(() => {
		if(applicationState) {
			handleAdvisorImage();
		}
	}, [applicationState]);

	const toggleToolTip = () => {
		setShowTooltip(!showTooltip);
	};

	const advisorImage = applicationState.advisorPhoto.getOrElse('');
	const closePdfPopup = () => {
		AnalysisApi.savedPdfUrl$.next("");
		SetPdfUrl("");
	};

	const handleAdvisorImage = async () => {
		const advrPhotoBase64 = getAdvisorDetails(applicationState).advisorPhoto.length ? await getBase64ImageFromUrl(getAdvisorDetails(applicationState).advisorPhoto) : null;
		const path = getLogoPath(applicationState.advisorLogo);
		const LogoBase64 =  path ? await getBase64ImageFromUrl(path) : null;
		SetAdvisorPhotoBase64Img(advrPhotoBase64);
		SetAdvisorLogoBase64Img(LogoBase64);
	};

	const handlePrintPageClick = async () => {
		LeadApi.showSpinner$.next(true);
		AnalysisApi.savedPdfUrl$.next("");
		// reset base64StringArray state
		setBase64StringArray([]);
		SetPdfUrl("");

		let advisorPhotoBase64: any = '';
		let advisorLogoBase64: any = '';
		
		if(advisorLogoBase64Img) {
			advisorLogoBase64 = advisorLogoBase64Img;
		}
		if(advisorPhotoBase64Img) {
			advisorPhotoBase64 = advisorPhotoBase64Img;
		}
		
		const promises = [];
		const investorName = `${leadProfile.Investor.FirstName} ${leadProfile.Investor.LastName}`;
		// Cover Page
		promises.push(getCoverPagePdfData(
			leadProfile.Investor.FirstName,
			leadProfile.Investor.LastName,
			JSON.stringify(getAdvisorDetails(applicationState)),
			advisorPhotoBase64,
			advisorLogoBase64
		));
		// First Page
		promises.push(getFirstPagePdfData(applicationState.companyName.getOrElse(''), investorName, goalAccountDetails, selectedRiskProfilImgUrl));
		//Second Page
		promises.push(getSecondPagePdfData(applicationState.companyName.getOrElse(''), investorName));
		//Third Page
		promises.push(getThirdPagePdfData(applicationState.companyName.getOrElse(''), investorName));
		//Fourth Page
		promises.push(getFourthPagePdfData(applicationState.companyName.getOrElse(''), investorName));
		//Fifth Page
		promises.push(getFifthPagePdfData(applicationState.companyName.getOrElse(''), investorName));
		//SixthPage
		promises.push(getSixthPagePdfData(applicationState.companyName.getOrElse(''), investorName));

		try {
			const result = await Promise.all(promises);
			result.forEach(async (response, index) => {
				try {
					const resultBlob = new Blob([response.data], { type: 'application/pdf' });
				const resultUrl = window.URL.createObjectURL(resultBlob);
				const base64String = await getByteArrayStringFromBlob(resultBlob);
				setBase64StringArray(current => {
					current[index] = base64String;
					return [...current];
				});
				} catch (error) {
					AnalysisApi.errorSubj$.next(new Error("pdf error"));
				}
			});
		} catch (error) {
			AnalysisApi.errorSubj$.next(new Error("save pdf error"));
		}
	};

	if (!staticImagesUrls.isSuccess()) {
		return <FullPageLoader />;
	}

	return (
		<div className={styles.analysisContainer}>
			<div className={styles.container}>
				<p className={styles.goalText}>
					We look forward to discussing how we can help you achieve your financial goal.
				</p>
				<div className={styles.contactPanel}>
					<div className={styles.panelTitle}>Your Financial Analysis</div>
					<div className={styles.btnContainer}>
						<Button
							name={'btnPrintPage'}
							className={`button button-lg ${styles.printPageBtn}`}
							text={'PRINT PAGE'}
							disabled={false}
							onClick={handlePrintPageClick}
						/>
						<div className={`${styles.tooltip}`}>
							<Button
								name={'btnContactMe'}
								className={`button button-lg ${styles.contectMeBtn}`}
								text={'CONTACT ME'}
								disabled={false}
								onClick={toggleToolTip}
							/>
							{showTooltip && (
								<TooltipComponent
									advisorImage={advisorPhotoBase64Img}
									advisorDetails={advisorDetail}
									click={toggleToolTip}
								/>
							)}
						</div>
					</div>
				</div>

				<div className={styles.details}>
					<AnalysisSideBarComponent goalAccountDetails={goalAccountDetails} />
					<div className={styles.rightPane}>
						<div className={styles.riskProfileImgContainer}>
							{selectedRiskProfilImgUrl && (
								<img data-ot-ignore src={selectedRiskProfilImgUrl} className={styles.riskProfileImg} />
							)}
						</div>
					</div>
				</div>
			</div>

			<div className={styles.blueBorder}></div>
			<div className={styles.learnMoreBox}>
				<div className={styles.arrowCircle}>
					<span>&#x2191;</span>
				</div>{' '}
				Learn more about the importance of investing and diversification in your financial life.
			</div>

			<div className={`${styles.financeImportanceContainer} ${styles.lightBlue}`}>
				<div className={styles.paddingContainer}>
					<div className={styles.message}>
						<p className={styles.mainMsg}>
							Importance of investing and diversification in your financial life.
						</p>
						<p className={styles.secondMsg}>
							Equities have been the best asset class for participating in long-term economic growth, but
							occasionally deliver nerve wracking declines.
						</p>
					</div>
					<div className={styles.imgContainer}>
						<h3 className={`${styles.imgTitle} ${styles.imgTitle1}`}>US Markets</h3>
						<div className={`${styles.staticImgBox} ${styles.staticImgBox1}`}>
							{staticFinancialImg1 && (
								<img data-ot-ignore
									src={staticFinancialImg1}
								/>
							)}
						</div>
					</div>
				</div>
				<div className={`${styles.paddingContainer} ${styles.illusMsg} ${styles.illusMsg1}`}>
					Charts are for illustrative purposes only. Past performance is no guarantee of future results.
					Investing involves risk, including the possible loss of principal, and there is no assurance that
					any investment strategy will be successful. One cannot invest directly in an index.Source: Zephyr
					Style Advisor. Data as of 12/31/2022. US Equities represented by S&P 500. US Bonds represented by
					the Bloomberg Barclays US Aggregate.
				</div>
			</div>

			<div className={`${styles.financeImportanceContainer}`}>
				<div className={styles.paddingContainer}>
					<div className={`${styles.message} ${styles.messageCycle}`}>
						<p className={styles.secondMsg}>
							Which can shake investor’s confidence, leading them to exit the market at the worst possible
							times, and to remain on the sidelines.
						</p>
					</div>
					<div className={styles.imgContainer}>
						<h3 className={styles.imgTitle}>The Cycle of Emotions may impact investor decision-making</h3>
						<div className={`${styles.staticImgBox} ${styles.growtImgBox}`}>
							{staticFinancialImg2 && (
								<>
									<img data-ot-ignore
										src={staticFinancialImg2}
									/>
								</>
							)}
						</div>
					</div>
				</div>
			</div>

			<div className={`${styles.financeImportanceContainer} ${styles.lightBlue}`}>
				<div className={`${styles.paddingContainer} ${styles.pb12}`}>
					<div className={styles.message}>
						<p className={`${styles.secondMsg} ${styles.secondColorCOde}`}>
							Getting out at the wrong time-and waiting too long to return - may have damaging impacts on
							returns.
						</p>
					</div>
					<div className={styles.imgContainer}>
						<h3 className={styles.imgTitle}>Growth of $1,000,000</h3>
						<div className={`${styles.staticImgBox}`}>
							{staticFinancialImg3 && (
								<img data-ot-ignore
									src={staticFinancialImg3}
								/>
							)}
						</div>
					</div>
				</div>
				<div className={`${styles.paddingContainer} ${styles.illusMsg}`}>
					Charts are for illustrative purposes only. Past performance is no guarantee of future results.
					Investing involves risk, including the possible loss of principal, and there is no assurance that
					any investment strategy will be successful. One cannot invest directly in an index. Source: Zephyr
					Style Advisor. Data as of 12/31/2022. Stay In – Invested in S&P 500 throughout. Get Out (-45%) –
					Moves to cash at month end after a 45% drop and waits for the market drawdown to fully recover
					before reinvesting.
				</div>
			</div>

			<div className={`${styles.financeImportanceContainer} ${styles.lastImgContainer}`}>
				<div className={styles.paddingContainer}>
					<div className={styles.message}>
						<p className={styles.secondMsg}>
							Investing Evolved was designed to allow more equity exposure in your portfolio with updated
							risk management techniques to provide a steadier experience during times of market stress.
						</p>
						<p className={`mt-3 ${styles.paraText}`}>
							<span className={styles.blueText}>Core markets</span> provide exposure to growth in domestic
							and global economies.
						</p>
						<p className={`mt-3 ${styles.paraText}`}>
							<span className={styles.lightGrayText}>Tactical strategies</span> provide supplemental
							returns through active equity management.
						</p>
						<p className={`mt-3 ${styles.paraText}`}>
							<span className={styles.lightGreenText}>Diversifying strategies</span> help manage equity
							risk, particularly during times of steep market declines.
						</p>
					</div>
					<div className={`my-0 mx-auto ${styles.imgContainer}`}>
						<div className={`${styles.lstImgBox}`}>
							{staticFinancialImg4 && (
								<img data-ot-ignore
									src={staticFinancialImg4}
									className={`${styles.imgRes}`}
								/>
							)}
						</div>
						<p className={`${styles.imgText}`}>
							Investing involves risk, including the possible loss of principal, and there is no assurance
							that any investment strategy will be successful.
						</p>
					</div>
				</div>
			</div>
		
		{pdfUrl && 
			<PDFModal onCloseModalClick={closePdfPopup}>
				<iframe data-ot-ignore name="test" src={`${pdfUrl}`} frameBorder="0" title="Modal" className={styles.pdfStyle} ></iframe>
			</PDFModal>
		}
		</div>
	);
};
